import Choices from "choices.js";
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Global {

    constructor() {
        this.initCookieTriggers();
        this.initChoices();
        this.initReviews();
        this.initUsps();
        setTimeout(() => {
            this.transitionAfterPageLoad();
        }, 300);
    }

    initCookieTriggers() {
        document.querySelectorAll('.cookietrigger').forEach(trigger => {
            trigger.classList.add('cky-banner-element');
        });
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    transitionAfterPageLoad(){
        document.querySelector("body").classList.remove("no-transition");
    }

    initUsps(){
        if(document.querySelector('#usps') !== null){
            new Swiper('#usps .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1000: {
                        slidesPerView: 4,
                    }
                }
            });
        }
    }

    initReviews(){
        if(document.querySelector('#reviews') !== null){
            new Swiper('#reviews .swiper-container', {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }
    }
}
